<div class="w-full h-screen overflow-y-scroll bg-(--ion-color-drawer)">
	<div class="w-full h-fit flex flex-col justify-start items-start px-[10px] pt-[10px] pb-40">
		<div class="w-full flex justify-between items-center gap-3 py-4 border-b border-b-(--ion-color-drawer-divider)">
			<div class="flex">
				<ion-icon name="person-outline" size="large" class="text-(--ion-color-drawer-title)"></ion-icon>
				<p class="text-2xl font-bold text-(--ion-color-drawer-title)">{{ helperService.getUsername() }}</p>
			</div>

			<ion-menu-toggle>
				<ion-button shape="round" fill="clear" class="w-fit">
					<ion-icon name="close-circle-outline" size="large" class="text-(--ion-color-drawer-title)" slot="icon-only"></ion-icon>
				</ion-button>
			</ion-menu-toggle>
		</div>

		<div class="w-full flex justify-start items-center gap-3 py-4 border-b border-b-(--ion-color-drawer-divider)">
			<p class="text-base font-bold text-(--ion-color-drawer-title)">{{ 'Balance' | translate }}:</p>
			<p class="text-base font-bold text-(--ion-color-drawer-title)">{{ showCurrency ? currency() : '' }} {{ balance() | number: '1.0-2' }}</p>
		</div>

		<div class="w-full flex flex-col justify-start items-start gap-5 py-4 border-b border-b-(--ion-color-drawer-divider)">
			<ion-menu-toggle appHideForDemoAccount class="w-full flex justify-start items-center gap-[10px] py-[10px]" (click)="goTo('my-profile')">
				<ion-icon color="light" name="person-outline"></ion-icon>
				<ion-text class="text-lg uppercase text-(--ion-color-light)">
					{{ 'My Profile' | translate }}
				</ion-text>
			</ion-menu-toggle>
			<ion-menu-toggle class="w-full flex justify-start items-center gap-[10px] py-[10px]" (click)="goTo('sports')">
				<ion-icon color="light" name="trophy-outline"></ion-icon>
				<ion-text class="text-lg uppercase text-(--ion-color-light)">
					{{ 'Sports' | translate }}
				</ion-text>
			</ion-menu-toggle>
			<ion-menu-toggle class="w-full flex justify-start items-center gap-[10px] py-[10px]" (click)="goTo('past-bets')">
				<ion-icon color="light" name="analytics"></ion-icon>
				<ion-text class="text-lg uppercase text-(--ion-color-light)">
					{{ 'Past Bets' | translate }}
				</ion-text>
			</ion-menu-toggle>
			<ion-menu-toggle class="w-full flex justify-start items-center gap-[10px] py-[10px]" (click)="goTo('account-statement')">
				<ion-icon color="light" name="document-text-outline"></ion-icon>
				<ion-text class="text-lg uppercase text-(--ion-color-light)">
					{{ 'Account Statement' | translate }}
				</ion-text>
			</ion-menu-toggle>
			<ion-menu-toggle class="w-full flex justify-start items-center gap-[10px] py-[10px]" (click)="goTo('profit-and-loss')">
				<ion-icon color="light" name="trending-up-outline"></ion-icon>
				<ion-text class="text-lg uppercase text-(--ion-color-light)">
					{{ 'Profit & Loss' | translate }}
				</ion-text>
			</ion-menu-toggle>
			<ion-menu-toggle appHideForDemoAccount class="w-full flex justify-start items-center gap-[10px] py-[10px]" (click)="goTo('change-password')">
				<ion-icon color="light" name="key-outline"></ion-icon>
				<ion-text class="text-lg uppercase text-(--ion-color-light)">
					{{ 'Change Password' | translate }}
				</ion-text>
			</ion-menu-toggle>
			<ion-menu-toggle class="w-full flex justify-start items-center gap-[10px] py-[10px]" (click)="goTo('bet-slip-settings')">
				<ion-icon color="light" name="construct-outline"></ion-icon>
				<ion-text class="text-lg uppercase text-(--ion-color-light)">
					{{ 'Bet Slip Settings' | translate }}
				</ion-text>
			</ion-menu-toggle>

			<div class="flex justify-start items-center gap-[10px]">
				<ion-icon color="light" name="language-outline"></ion-icon>
				<ion-select placeholder="Select Language" [formControl]="languageFormControl" class="w-min text-(--ion-color-light)">
					@for (language of SUPPORTED_LANGUAGES; track language.name) {
						<ion-select-option [value]="language.symbol" class="text-(--ion-color-light)">{{ language.name | translate }}</ion-select-option>
					}
				</ion-select>

				@if (isUpdatingLanguage()) {
					<ion-spinner></ion-spinner>
				}
			</div>

			<div class="flex justify-start items-center gap-[10px]">
				<ion-icon color="light" name="text"></ion-icon>
				<ion-select placeholder="Select Font Size" [formControl]="fontSizeFormControl" class="w-min text-(--ion-color-light)" interface="action-sheet">
					@for (option of fontSizeService.fontSizeOptions; track option.key) {
						<ion-select-option [value]="option.key" class="text-(--ion-color-light)">{{ option.label | translate }}</ion-select-option>
					}
				</ion-select>
			</div>
		</div>

		<div class="w-full flex flex-col justify-start items-start gap-5 py-4 border-b border-b-(--ion-color-drawer-divider)">
			<ion-menu-toggle class="w-full flex justify-start items-center gap-[10px] py-[10px]" (click)="logOut()">
				<ion-icon color="light" name="log-out-outline"></ion-icon>
				<ion-text class="text-lg uppercase text-(--ion-color-light)">
					{{ 'Logout' | translate }}
				</ion-text>
			</ion-menu-toggle>
			@if (showFeedbackButton) {
				<app-sentry-feedback></app-sentry-feedback>
			}
		</div>

		@if (!environment.production || environment.environment === 'DEV') {
			<ion-text class="text-(--ion-color-light) text-xs font-extralight">{{ 'Version' | translate }}: {{ getVersion() }}</ion-text>
		}
	</div>
</div>
